import { useCallback, useState } from "react";
import axios from "axios";
import { IJourneyLevel } from "./types";
import apiPaths from "../../../api/endpoints";

import apiClientTwo from "../../../api/apiClient2";

// const CONTENT_BASE_URL = "https://content-delivery.dev.yetimyfriend.com/api/";

const getAuthToken = (): string | null => {
  try {
    const token = localStorage.getItem("UserAccessToken");
    return token ? JSON.parse(token) : null;
  } catch {
    return null;
  }
};

const createAuthHeaders = () => {
  const token = getAuthToken();
  return {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const useJourneyData = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJourneyLevels = useCallback(
    async (endpoint = "?journeyPage=true") => {
      try {
        setLoading(true);
        setError(null);

        const response = await apiClientTwo.get(
          `${apiPaths.CONTENT_BASE_URL3}/v3/retrieveStory${endpoint}`,
        );

        const summaries: IJourneyLevel[] =
          response?.data?.data?.storySummaries?.slice(0, -1) || [];

        console.log(summaries, "summariessummariessummaries");

        return summaries;
      } catch (err: any) {
        console.error("Get User API error:", err);
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Something went wrong",
        );
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const fetchMagicBackpackContent = useCallback(
    async (contentType: "Video" | "Audio") => {
      const response = await axios.get(
        `${apiPaths.CONTENT_BASE_URL3}/retrieveMagicBackpack/${contentType}`,
        { headers: createAuthHeaders() },
      );
      return response.data;
    },
    [],
  );

  const extractStoryId = (url: string): string => {
    const match = url.match(/(?<=retrieveStory).*/);
    return match ? match[0] : "";
  };

  return { fetchJourneyLevels, fetchMagicBackpackContent, extractStoryId };
};
